import { connect } from 'react-redux';
import GroundMount from './GroundMount';

import { setHorizonLengthChange, setYearSliderChange } from '../../../../../common/settings/actions';
import { getAnnualResults } from '../../selectors';


const mapStateToProps = state => ({
    horizonLength: state.settings.horizonLength,
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
    resiToggle: state.tax.resiToggle,
    provider: state.utility.provider,
    projectState: state.projectaddress.projectState,
    setHorizonLengthChange,
    setYearSliderChange,
});

const combinedActions = {
    setHorizonLengthChange,
    setYearSliderChange,
};

export default connect(mapStateToProps, combinedActions)(GroundMount);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/GroundMount/index.js